import axios from "axios";

export async function getShopList() {
  return axios.get(`/api/planner/shops`)
    .then(res => res.data)
}

export const fetchOperationPolicy = (shopId) => {
  return axios.get(`/api/planner/shops/operation-policy?shopId=${shopId}`)
    .then(res => res.data);
}
